import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { DynamicRoutesService } from 'src/app/services/dynamic-routes.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-dynamic-routes',
  templateUrl: './edit-dynamic-routes.component.html',
  styleUrls: ['./edit-dynamic-routes.component.scss']
})
export class EditDynamicRoutesComponent implements OnInit {

  PathPatternId: string;

  PathPatternSectionId: string;

  PathPatternSectionTypeId: string;

  AllowEdit: string;

  search = '';
  token = ''
  breadcrumbs = []
  ProcedureValue:any = {}

  tipoSeccionOptions = []
  tiposecctionIds = []
  tipoSeccion = '';
  editableCheck = false;

  isEditableInitial = false;

  campos = []
  patron_list = [];
  patron = '';
  user_id: any;

  constructor(private activeRoute: ActivatedRoute,private router: Router,
              private dynamic: DynamicRoutesService,private _snackBar: MatSnackBar,
              public dialog: MatDialog) { }

  ngOnInit(): void {

    this.activeRoute.paramMap.subscribe(params => {
      this.PathPatternId = params.get('PathPatternId');
      this.PathPatternSectionId = params.get('PathPatternSectionId');
    });

    this.token = localStorage.getItem('token')
    this.user_id = localStorage.getItem('user_id');
    if(this.user_id != null)
    {
      this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))

      this.activeRoute.params.subscribe(params => {

        let formT = localStorage.getItem('formTransliterator')
        if (formT == null){
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Rutas dinámicas', url: '/routes'},
            {name: 'editar', url: `/edit_routes/${this.PathPatternId}/${this.PathPatternSectionId}`},
          ]
        }

      })
    }
    else this.exit()

    this.dynamic.getPathPatternSectionTypes().subscribe({
      next:res=>{
        this.tipoSeccionOptions = res.map(val=>val.Name);
        this.tiposecctionIds = res.map(val=>val.IdValue);
      },
      complete:()=>{
        this.dynamic.getPathPatternSectionsByPathPatternIdAndSectionId(this.PathPatternId,this.PathPatternSectionId).subscribe({
          next:res=>{
            if(!res) this.exit();
            console.log(res);
            if(res['AllowEdit']=='No') this.back();
            console.log(res);
            this.patron = res['PatternSection'];
            this.patron_list = this.patronToArray(this.patron);
            this.PathPatternSectionTypeId = res['PathPatternSectionTypeId'];
            this.tipoSeccion = this.tipoSeccionOptions[this.tiposecctionIds.indexOf(this.PathPatternSectionTypeId)];
            this.AllowEdit = res['AllowEdit']!='No'?'1':'0' ;
            this.editableCheck = this.AllowEdit!='0'?true:false;
            this.isEditableInitial = res['AllowEdit']!='No'?true:false;
          }
        })
      }
    })

    this.dynamic.getPathPatternFields().subscribe({
      next: res => this.campos = res.map(item=>item['PatternField'])
    })

  }

  exit(): void{
    this.router.navigate(['/'])
  }

  back(): void{
    this.router.navigate([`routes/${this.PathPatternId}`])
  }

  patronToArray(patron:string):string[]{
    let divisor = '/\\'
    return patron.replace(/\//g,`${divisor}/${divisor}`).split('/\\');
  }

  moveItem(moveTo:string, index:number){
    let aux;
    if(moveTo == 'up' && this.patron_list.length-1>index){
      aux = this.patron_list[index+1];
      this.patron_list[index+1] = this.patron_list[index];
      this.patron_list[index] = aux;
    }
    else if(moveTo == 'down' && index>0){
      aux = this.patron_list[index-1];
      this.patron_list[index-1] = this.patron_list[index];
      this.patron_list[index] = aux;
    }
    this.uptadePath()
  }

  deleteItem(index:number){
    this.patron_list.splice(index,1)
    this.uptadePath();
  }

  addToPaht(campo:String){
    this.patron_list.push(campo)
    this.uptadePath();
  }

  cleanSearch(){
    this.search = '';
  }

  uptadePath(){
    this.patron_list = [...this.patron_list]
    const regex = /,/gi;
    this.patron = this.patron_list.join().replace(regex,'')
  }

  saveChanges(){

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {'title': 'Alerta:',
        'subtitle': '¿Está seguro de actualizar los datos?'}
    });
    dialogRef.afterClosed().subscribe(
      res=>{
        if(res){
          let patron = this.patron.replace(/%/g, "%25");
          this.dynamic.postUpdatePathPatternFields(this.PathPatternSectionId,this.PathPatternId,this.PathPatternSectionTypeId,this.editableCheck?'1':'0',patron).subscribe({
            next:res=>{
              if(res[0]['Action'] == 'Updated'){
                if(!this.editableCheck){
                  this.back();
                }
                this._snackBar.open('Datos actualizados con éxito.','cerrar',{duration:6000});
              }
            }
          })
        }
      });


  }


}
